import React, { useMemo, forwardRef } from 'react';
import classNames from 'classnames';
import { Typography } from '../../../Typography';
import "./styles.css";
export var HelperContent = forwardRef(function (_a, ref) {
    var title = _a.title, body = _a.body, className = _a.className;
    var titleValue = useMemo(function () {
        return title ? (typeof title === 'string' ? (React.createElement(Typography, { className: 'lk-ui_helper-title', variant: 'h5' }, title)) : (React.createElement("div", { className: 'lk-ui_helper-title' }, title))) : undefined;
    }, [title]);
    var bodyValue = useMemo(function () {
        return typeof body === 'string' ? (React.createElement(Typography, { className: 'lk-ui_helper-body', variant: 'caption' }, body)) : (React.createElement("div", { className: 'lk-ui_helper-body' }, body));
    }, [body]);
    return (React.createElement("div", { ref: ref, className: classNames('lk-ui_helper', className) },
        titleValue,
        bodyValue));
});
